import { ref } from 'vue'

export const instanceLoaded = ref(false)
export const verificationDuring = ref(0)
export var ftxIdentityLiteInstance = ref(null)
